"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _rgbaOrHexString_1 = require("./_rgbaOrHexString");
/**
 * Gets a color with the given alpha value and the same other components as `color`.
 * Does not modify the original color.
 */
function updateA(color, a) {
    return tslib_1.__assign({}, color, { a: a, str: _rgbaOrHexString_1._rgbaOrHexString(color.r, color.g, color.b, a, color.hex) });
}
exports.updateA = updateA;
//# sourceMappingURL=updateA.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/utilities/color/updateA.js
// module id = 813
// module chunks = 0